import { render, staticRenderFns } from "./StoryViewer.vue?vue&type=template&id=08ec88d3&scoped=true&"
import script from "./StoryViewer.vue?vue&type=script&lang=js&"
export * from "./StoryViewer.vue?vue&type=script&lang=js&"
import style0 from "./StoryViewer.vue?vue&type=style&index=0&id=08ec88d3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ec88d3",
  null
  
)

export default component.exports